import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

const APIDocsCreateEntryBlock = () => {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Create entry</div>
        <div className="text">Creates and (optionally) publishes a new changelog entry.</div>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description: 'The title of your changelog entry.',
              heading: 'title',
              subheading: 'string',
            },
            {
              description: 'The details of your changelog entry.',
              heading: 'details',
              subheading: 'string',
            },
            {
              description:
                'The type of your changelog entry. Can be one of "fixed", "new", and "improved".',
              heading: 'type',
              subheading: 'string (optional)',
            },
            {
              description: 'Whether to notify users by email after publishing. Default is false.',
              heading: 'notify',
              subheading: 'boolean (optional)',
            },
            {
              description:
                'Whether you want to publish the changelog entry immediately or not. Default is false.',
              heading: 'published',
              subheading: 'boolean (optional)',
            },
            {
              description:
                'If published is set to true and you would like to set a published date in the past, in ISO 8601 format.',
              heading: 'publishedOn',
              subheading: 'string (optional)',
            },
            {
              description:
                'The date you want the changelog entry to be published, in ISO 8601 format. This has to be in the future.',
              heading: 'scheduledFor',
              subheading: 'string (optional)',
            },
            {
              description:
                'A list of labels to assign to your changelog entry. Each label must be between 1 and 30 characters long.',
              heading: 'labelIDs',
              subheading: 'array (optional)',
            },
            {
              description: 'A list of posts to link to your changelog entry.',
              heading: 'postIDs',
              subheading: 'array (optional)',
            },
          ]}
        />
        <div className="subheading">Returns</div>
        <div className="text">Upon success, returns an object with a single key: id.</div>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v1/entries/create</Highlight>
        <APIDocsMethod />
        <APIDocsCurl
          path="https://canny.io/api/v1/entries/create"
          body={`\\
  -d apiKey=YOUR_API_KEY \\
  -d title="Sample entry" \\
  -d details="Some details..." \\
  -d type="fixed" \\
  `}
        />
        <div className="text">Example Response</div>
        <Highlight lang="json">
          {`{
  "id": "553c3ef8b8cdcd1501ba1240",
}`}
        </Highlight>
      </div>
    </APIDocsBlock>
  );
};

export default APIDocsCreateEntryBlock;
